import { Observable } from 'rxjs';
import { Component, OnDestroy } from '@angular/core';
import { map } from 'rxjs/operators';

import { MarketplaceKeys } from '@config/keys/shop.keys';
import { OrderStoreDispatcher } from '@common/dispatchers/order.dispatcher';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ModalsService } from '@core/services/modals/modals.service';
import { roundTipAmountCents } from '@shared/utils/currency/round-tip-amount.util';

import { ModalStoreSelector } from '@common/selectors/modal.selector';
import { CartStoreDispatcher } from '@common/dispatchers/cart.dispatcher';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { ModalScrollBlockBase } from '@core/base/modalScrollBlock/modal-scroll-block.base';

@Component({
  selector: 'app-cart-tip-picker-modal',
  templateUrl: './cart-tip-picker-modal.component.html',
  standalone: false,
})
export class CartTipPickerModalComponent extends ModalScrollBlockBase implements OnDestroy {
  static handle = 'cart-tip-picker-modal';

  index$: Observable<number> = this.modalSelector
    .selectModal(CartTipPickerModalComponent.handle)
    .pipe(map(el => (el?.index ? el.index : 4)));

  error = false;

  constructor(
    private modalSelector: ModalStoreSelector,
    private cartDispatcher: CartStoreDispatcher,
    private readonly modalsService: ModalsService,
    private readonly orderDispatcher: OrderStoreDispatcher,
    readonly settingsSelector: SettingsStoreSelector,
    private readonly marketplaceSelector: MarketplaceStoreSelector,
  ) {
    super();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  closeTipModal(): void {
    this.modalsService.close(CartTipPickerModalComponent.handle);
  }

  onApplyTip(tip: number): void {
    const currency = this.marketplaceSelector.marketplace?.[MarketplaceKeys.Currency];
    const cents = roundTipAmountCents(Math.round(tip * 100), currency);
    tip = cents / 100;
    if (tip > 0 && tip < 100) {
      this.cartDispatcher.updateActive({ tip: tip * 100 });
      this.modalsService.close(CartTipPickerModalComponent.handle);
      this.orderDispatcher.checkCartIsValid();
      this.error = false;
      return;
    }
    this.error = true;
  }
}
